import { useEffect, useState, type CSSProperties } from 'react';
import { api } from '../../lib/api';

export function MyProofImage({ proofId, style }: { proofId: string; style?: CSSProperties }) {
  const [url, setUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let obj: string | null = null;
    let live = true;
    api.proofs.myImageBlob(proofId).then((b) => { if (!live) return; obj = URL.createObjectURL(b); setUrl(obj); }).catch(() => live && setFailed(true));
    return () => { live = false; if (obj) URL.revokeObjectURL(obj); };
  }, [proofId]);
  if (failed) return <div style={{ ...style, display: 'grid', placeItems: 'center', color: 'var(--text-hint)', fontSize: 12 }}>Sin imagen</div>;
  if (!url) return <div style={{ ...style, background: 'var(--surface-2)' }} />;
  return <img src={url} alt="Comprobante" style={{ ...style, objectFit: 'cover' }} />;
}
